import React, { useState, useEffect } from 'react';
import './CandidateProfile.css';
import { getCandidateList } from "./Service/RecruitmentService";

export default function CandidateProfile({ candidateId }) {
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("overview");
  const [toastMsg, setToastMsg] = useState(null);

  const [editModal, setEditModal] = useState(false);
  const [addNoteModal, setAddNoteModal] = useState(false);
  const [feedbackModal, setFeedbackModal] = useState(false);
  const [createEmpModal, setCreateEmpModal] = useState(false);
  const [feedbackSub, setFeedbackSub] = useState("Round 2 — HR Interview · Rahul Kumar");

  const [r1, setR1] = useState(0);
  const [r2, setR2] = useState(0);
  const [r3, setR3] = useState(0);
  const [r4, setR4] = useState(0);

  // ── Fallback / demo data (used until API responds, or if API fails) ──
  const fallbackProfile = {
    Name: "Rahul Kumar",
    Initials: "RK",
    Role: "Senior Frontend Developer",
    ExperienceYears: 5,
    StageLabel: "Interview — Round 2",
    Email: "rahul.kumar@gmail.com",
    Phone: "+91 99001 23456",
    Location: "Delhi, India",
    ExpectedCTC: "14–18 LPA",
    NoticePeriod: "30 days",
    WorkMode: "Remote / Hybrid",
    Source: "ATS — Direct Apply",
    AddedBy: "Auto · Jun 3, 2026",
    CurrentJob: {
      JobCode: "JOB-2026-001",
      Stage: "Interview",
      Round: "R2 — HR Interview",
      InterviewTime: "Today 11 AM",
      Recruiter: "Priya Sharma",
    },
    QuickStats: {
      JobsApplied: 2,
      InterviewRounds: 3,
      RoundsCleared: 2,
      DaysInSystem: 23,
    },
    About:
      "Senior Frontend Developer with 5 years of experience in React and TypeScript. Passionate about clean code and design systems. Open source contributor. Mentored junior developers at previous company.",
    CurrentCompany: "OrgGenie Technologies",
    PrimarySkills: ["React", "TypeScript", "Next.js", "Redux", "CSS/SCSS", "Webpack", "Git", "Jest"],
    SecondarySkills: ["Node.js", "Figma", "Storybook"],
    Experience: [
      {
        Company: "OrgGenie Technologies Pvt Ltd",
        Role: "Senior Frontend Developer",
        Dates: "Jan 2022 – Present · 2.5 yrs · Delhi",
        Current: true,
        Desc: "Led dashboard migration from class components to hooks; improved load time 40%; built component library.",
      },
      {
        Company: "StartupBase Inc",
        Role: "Frontend Developer",
        Dates: "Jun 2019 – Dec 2021 · 2.5 yrs · Bengaluru (Remote)",
        Current: false,
        Desc: "Built e-commerce frontend from scratch, integrated payment gateways, React+Redux.",
      },
    ],
    Education: [
      {
        Degree: "B.Tech — Computer Science",
        School: "Delhi Technological University",
        Dates: "2015 – 2019 · 8.2 CGPA",
      },
    ],
    Notes: [
      {
        Text: "Candidate showed excellent React knowledge. The live coding round went well — identified performance issues quickly. Strong communicator. Good cultural fit. Recommend proceeding to HR round.",
        AuthorInitials: "RD",
        AuthorColor: "#0891b2",
        Author: "Rahul Dev",
        Panel: "R1 Technical Interview Panel",
        Time: "Jun 8, 2026 · 3d ago",
        Highlight: false,
      },
      {
        Text: "Reached out proactively before the interview to confirm details. Very professional. LinkedIn profile is strong — recent project on GitHub shows real-world Next.js experience. Strong candidate.",
        AuthorInitials: "PS",
        AuthorColor: "#EC4119",
        Author: "Priya Sharma",
        Panel: "HR",
        Time: "Jun 5, 2026 · 6d ago",
        Highlight: true,
      },
    ],
    Activity: [
      {
        Color: "var(--amber)",
        Icon: "fa-calendar",
        Title: "Round 2 scheduled",
        Text: "HR Interview on Jun 26, 11:00 AM. Panel: Priya Sharma. Mode: Google Meet.",
        Time: "Today 9:00 AM · Priya Sharma",
      },
      {
        Color: "var(--green)",
        Icon: "fa-check",
        Title: "Round 1 cleared",
        Text: "Technical Screening passed (Rating: 8.5/10). Stage moved to Interview.",
        Time: "Jun 8 4:30 PM · Rahul Dev",
      },
      {
        Color: "#fbbf24",
        Icon: "fa-star",
        Title: "Feedback submitted",
        Text: "R1 Technical: Technical 8/10, Communication 9/10, Problem Solving 8/10. Recommendation: Proceed.",
        Time: "Jun 8 3:45 PM · Rahul Dev",
      },
      {
        Color: "var(--amber)",
        Icon: "fa-calendar",
        Title: "Round 1 scheduled",
        Text: "Technical Screening on Jun 8, 10:00 AM. Panel: Rahul Dev. Mode: Zoom.",
        Time: "Jun 6 2:00 PM · Priya Sharma",
      },
      {
        Color: "#6366f1",
        Icon: "fa-arrow-right",
        Title: "Stage updated",
        Text: "Applied → Interview (after resume shortlisting by HR).",
        Time: "Jun 6 1:30 PM · Priya Sharma",
      },
      {
        Color: "var(--primary)",
        Icon: "fa-user-plus",
        Title: "Applied",
        Text: "via ATS portal to Senior Frontend Developer (JOB-2026-001). CV auto-parsed.",
        Time: "Jun 3 11:22 AM · System",
      },
    ],
    Applications: [
      {
        Title: "Senior Frontend Developer",
        Meta: "JOB-2026-001 · Engineering · Applied Jun 3, 2026",
        StageLabel: "Interview — R2",
        StageCls: "sb-interview",
        Archived: false,
      },
      {
        Title: "Full Stack Developer",
        Meta: "JOB-2025-088 · Product · Mar 15, 2025 · Previous cycle",
        StageLabel: "Rejected — R1",
        StageCls: "sb-rejected",
        Archived: true,
      },
    ],
    InterviewRounds: [
      {
        Day: "26",
        Month: "Jun",
        BarColor: "var(--amber)",
        Title: "Round 2 — HR Interview",
        Meta: "JOB-2026-001 · Panel: Priya Sharma · 11:00 AM – 12:00 PM · Google Meet",
        StatusLabel: "Scheduled · Today",
        StatusBg: "var(--amber-lt)",
        StatusColor: "var(--amber)",
        Action: "feedback",
      },
      {
        Day: "8",
        Month: "Jun",
        BarColor: "var(--green)",
        Title: "Round 1 — Technical Screening",
        Meta: "JOB-2026-001 · Panel: Rahul Dev · 10:00 AM – 11:00 AM · Zoom",
        Scores: "Technical 8/10 · Comm. 9/10 · Problem Solving 8/10",
        StatusLabel: "Cleared",
        StatusBg: "var(--green-lt)",
        StatusColor: "var(--green)",
        Action: "view",
        Preset: "8",
      },
    ],
  };

  const [profile, setProfile] = useState(fallbackProfile);

  function showToast(msg) {
    setToastMsg(msg);
    setTimeout(() => setToastMsg(null), 2800);
  }

  // ── API integration ──
  const fetchCandidateProfile = async (id) => {
    setLoading(true);
    const params = {
      CandidateId: id || 0,
      Guid: "JDHDVSJS2633",
    };

    try {
      const res = await getCandidateList(params);
      if (res?.Data) {
        const d = res.Data;
        setProfile({
          Name: d?.Name ?? fallbackProfile.Name,
          Initials: d?.Initials ?? fallbackProfile.Initials,
          Role: d?.Role ?? fallbackProfile.Role,
          ExperienceYears: d?.ExperienceYears ?? fallbackProfile.ExperienceYears,
          StageLabel: d?.StageLabel ?? fallbackProfile.StageLabel,
          Email: d?.Email ?? fallbackProfile.Email,
          Phone: d?.Phone ?? fallbackProfile.Phone,
          Location: d?.Location ?? fallbackProfile.Location,
          ExpectedCTC: d?.ExpectedCTC ?? fallbackProfile.ExpectedCTC,
          NoticePeriod: d?.NoticePeriod ?? fallbackProfile.NoticePeriod,
          WorkMode: d?.WorkMode ?? fallbackProfile.WorkMode,
          Source: d?.Source ?? fallbackProfile.Source,
          AddedBy: d?.AddedBy ?? fallbackProfile.AddedBy,
          CurrentJob: d?.CurrentJob ?? fallbackProfile.CurrentJob,
          QuickStats: d?.QuickStats ?? fallbackProfile.QuickStats,
          About: d?.About ?? fallbackProfile.About,
          CurrentCompany: d?.CurrentCompany ?? fallbackProfile.CurrentCompany,
          PrimarySkills: d?.PrimarySkills?.length ? d.PrimarySkills : fallbackProfile.PrimarySkills,
          SecondarySkills: d?.SecondarySkills?.length ? d.SecondarySkills : fallbackProfile.SecondarySkills,
          Experience: d?.Experience?.length ? d.Experience : fallbackProfile.Experience,
          Education: d?.Education?.length ? d.Education : fallbackProfile.Education,
          Notes: d?.Notes?.length ? d.Notes : fallbackProfile.Notes,
          Activity: d?.Activity?.length ? d.Activity : fallbackProfile.Activity,
          Applications: d?.Applications?.length ? d.Applications : fallbackProfile.Applications,
          InterviewRounds: d?.InterviewRounds?.length ? d.InterviewRounds : fallbackProfile.InterviewRounds,
        });
      }
    } catch (error) {
      // keep fallback data on failure
      console.error("Failed to load candidate profile", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCandidateProfile(candidateId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [candidateId]);

  function RatingRow({ value, onChange }) {
    return (
      <div style={{ display: "flex", gap: ".15rem" }}>
        {Array.from({ length: 10 }, (_, i) => i + 1).map((n) => {
          const active = n <= value;
          return (
            <button
              key={n}
              type="button"
              onClick={() => onChange(n)}
              style={{
                width: 19,
                height: 19,
                borderRadius: 3,
                border: `1.5px solid ${active ? "#EC4119" : "#e8edf2"}`,
                background: active ? "#EC4119" : "#f3f4f6",
                color: active ? "#fff" : "#6b7280",
                cursor: "pointer",
                fontSize: ".6rem",
                fontWeight: 700,
                padding: 0,
                transition: ".1s",
              }}
            >
              {n}
            </button>
          );
        })}
      </div>
    );
  }

  function openFeedbackViewModal(round) {
    setFeedbackSub(`${round.Title} (View only)`);
    const preset = parseInt(round.Preset || "0", 10);
    setR1(preset);
    setR2(preset);
    setR3(preset);
    setR4(preset);
    setFeedbackModal(true);
  }

  function openFeedbackModalFresh() {
    setFeedbackSub(`${profile.CurrentJob?.Round || "Round"} · ${profile.Name}`);
    setR1(0);
    setR2(0);
    setR3(0);
    setR4(0);
    setFeedbackModal(true);
  }

  return (
    <>
    

      {/* <div className="main"> */}
        <div className="topbar">
          <i className="fa-solid fa-user-tie" style={{ color: "var(--primary)" }}></i>
          <div className="breadcrumb" style={{ margin: 0 }}>
            <a href="recruitment-candidates.html">Candidates</a>
            <i className="fa-solid fa-chevron-right" style={{ fontSize: ".6rem" }}></i>
            <strong style={{ color: "var(--text)" }}>{profile.Name}</strong>
          </div>
          <div className="top-right">
            <div style={{ display: "flex", alignItems: "center", gap: ".5rem" }}>
              <div className="top-avatar">AM</div>
              <div>
                <div style={{ fontWeight: 600, fontSize: ".8rem" }}>Arun Mishra</div>
                <div style={{ fontSize: ".68rem", color: "var(--muted)" }}>HR Admin</div>
              </div>
            </div>
          </div>
        </div>

        <div className="page-body">
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginBottom: "1.25rem",
              flexWrap: "wrap",
              gap: ".75rem",
            }}
          >
            <div className="breadcrumb" style={{ margin: 0 }}>
              <a href="recruitment-candidates.html">
                <i className="fa-solid fa-arrow-left" style={{ fontSize: ".7rem" }}></i> Back to Candidates
              </a>
            </div>
            <div style={{ display: "flex", gap: ".5rem", flexWrap: "wrap" }}>
              <button className="btn btn-outline btn-sm" onClick={() => setEditModal(true)}>
                <i className="fa-solid fa-pen"></i> Edit
              </button>
              <button className="btn btn-outline btn-sm" onClick={() => {}}>
                <i className="fa-solid fa-link"></i> Link to Job
              </button>
              <button className="btn btn-outline btn-sm" onClick={() => {}}>
                <i className="fa-solid fa-calendar-plus"></i> Schedule Interview
              </button>
              <button className="btn btn-warn btn-sm" onClick={openFeedbackModalFresh}>
                <i className="fa-solid fa-star"></i> Add Feedback
              </button>
              <button className="btn btn-primary btn-sm" onClick={() => setCreateEmpModal(true)}>
                <i className="fa-solid fa-user-check"></i> Create Employee
              </button>
            </div>
          </div>

          {loading && (
            <div style={{ marginBottom: "1rem", fontSize: ".8rem", color: "var(--muted)" }}>
              Loading candidate profile…
            </div>
          )}

          <div className="profile-layout">
            {/* Sidebar */}
            <div className="profile-sidebar">
              <div className="profile-card">
                <div className="pc-header">
                  <div className="pc-av">{profile.Initials}</div>
                  <div className="pc-name">{profile.Name}</div>
                  <div className="pc-role">
                    {profile.Role} · {profile.ExperienceYears} yrs
                  </div>
                  <div className="pc-stage">
                    <span
                      style={{
                        fontSize: ".72rem",
                        fontWeight: 700,
                        background: "rgba(255,255,255,.15)",
                        color: "#fff",
                        padding: "3px 10px",
                        borderRadius: "20px",
                      }}
                    >
                      {profile.StageLabel}
                    </span>
                  </div>
                </div>
                <div className="pc-body">
                  <div className="pc-row">
                    <i className="fa-solid fa-envelope"></i>
                    <div>
                      <div className="pc-label">Email</div>
                      <div className="pc-value">{profile.Email}</div>
                    </div>
                  </div>
                  <div className="pc-row">
                    <i className="fa-solid fa-phone"></i>
                    <div>
                      <div className="pc-label">Phone</div>
                      <div className="pc-value">{profile.Phone}</div>
                    </div>
                  </div>
                  <div className="pc-row">
                    <i className="fa-solid fa-location-dot"></i>
                    <div>
                      <div className="pc-label">Location</div>
                      <div className="pc-value">{profile.Location}</div>
                    </div>
                  </div>
                  <div className="pc-row">
                    <i className="fa-solid fa-briefcase"></i>
                    <div>
                      <div className="pc-label">Experience</div>
                      <div className="pc-value">{profile.ExperienceYears} years</div>
                    </div>
                  </div>
                  <div className="pc-row">
                    <i className="fa-solid fa-indian-rupee-sign"></i>
                    <div>
                      <div className="pc-label">Expected CTC</div>
                      <div className="pc-value">{profile.ExpectedCTC}</div>
                    </div>
                  </div>
                  <div className="pc-row">
                    <i className="fa-solid fa-user-clock"></i>
                    <div>
                      <div className="pc-label">Notice Period</div>
                      <div className="pc-value">{profile.NoticePeriod}</div>
                    </div>
                  </div>
                  <div className="pc-row">
                    <i className="fa-solid fa-house-laptop"></i>
                    <div>
                      <div className="pc-label">Preference</div>
                      <div className="pc-value">{profile.WorkMode}</div>
                    </div>
                  </div>
                  <div className="pc-sec">Candidate Source</div>
                  <span className="source-badge src-ats">{profile.Source}</span>
                  <div className="pc-sec" style={{ marginTop: ".65rem" }}>
                    Added By
                  </div>
                  <div style={{ fontSize: ".8rem", color: "var(--muted)" }}>{profile.AddedBy}</div>
                  <div className="pc-sec" style={{ marginTop: ".65rem" }}>
                    Resume
                  </div>
                  <button
                    className="btn btn-outline btn-sm"
                    style={{ width: "100%", justifyContent: "center", marginTop: ".2rem" }}
                    onClick={() => showToast("Downloading resume…")}
                  >
                    <i className="fa-solid fa-download"></i> Download Resume
                  </button>
                  <div style={{ marginTop: ".9rem", paddingTop: ".75rem", borderTop: "1px solid var(--border)" }}>
                    <div className="pc-sec">Quick Links</div>
                    <div style={{ display: "flex", gap: ".4rem", flexWrap: "wrap", marginTop: ".3rem" }}>
                      <button className="btn btn-outline btn-xs">
                        <i className="fa-brands fa-linkedin"></i>
                      </button>
                      <button className="btn btn-outline btn-xs">
                        <i className="fa-brands fa-github"></i>
                      </button>
                      <button className="btn btn-outline btn-xs" onClick={() => showToast("Portfolio opened")}>
                        <i className="fa-solid fa-globe"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              {/* Current job status card */}
              <div className="profile-card">
                <div style={{ padding: ".85rem 1rem", borderBottom: "1px solid var(--border)" }}>
                  <div style={{ fontSize: ".82rem", fontWeight: 700 }}>Current Job Status</div>
                </div>
                <div style={{ padding: ".85rem 1rem" }}>
                  <div style={{ display: "flex", justifyContent: "space-between", fontSize: ".8rem", marginBottom: ".4rem" }}>
                    <span style={{ color: "var(--muted)" }}>Job</span>
                    <span style={{ fontWeight: 600, color: "var(--blue)" }}>{profile.CurrentJob?.JobCode}</span>
                  </div>
                  <div style={{ display: "flex", justifyContent: "space-between", fontSize: ".8rem", marginBottom: ".4rem" }}>
                    <span style={{ color: "var(--muted)" }}>Stage</span>
                    <span style={{ fontWeight: 700, color: "#c2410c" }}>{profile.CurrentJob?.Stage}</span>
                  </div>
                  <div style={{ display: "flex", justifyContent: "space-between", fontSize: ".8rem", marginBottom: ".4rem" }}>
                    <span style={{ color: "var(--muted)" }}>Round</span>
                    <span style={{ fontWeight: 600 }}>{profile.CurrentJob?.Round}</span>
                  </div>
                  <div style={{ display: "flex", justifyContent: "space-between", fontSize: ".8rem", marginBottom: ".4rem" }}>
                    <span style={{ color: "var(--muted)" }}>Interview</span>
                    <span style={{ fontWeight: 600, color: "var(--primary)" }}>{profile.CurrentJob?.InterviewTime}</span>
                  </div>
                  <div style={{ display: "flex", justifyContent: "space-between", fontSize: ".8rem", marginBottom: ".6rem" }}>
                    <span style={{ color: "var(--muted)" }}>Recruiter</span>
                    <span style={{ fontWeight: 600 }}>{profile.CurrentJob?.Recruiter}</span>
                  </div>
                  <button className="btn btn-primary btn-xs" style={{ width: "100%", justifyContent: "center" }} onClick={() => {}}>
                    View in Pipeline
                  </button>
                </div>
              </div>
            </div>

            {/* Right content */}
            <div>
              {/* Tab bar */}
              <div className="tab-bar">
                <button
                  className={`tab-btn ${activeTab === "overview" ? "active" : ""}`}
                  onClick={() => setActiveTab("overview")}
                >
                  <i className="fa-solid fa-house"></i> Overview
                </button>
                <button
                  className={`tab-btn ${activeTab === "applications" ? "active" : ""}`}
                  onClick={() => setActiveTab("applications")}
                >
                  <i className="fa-solid fa-briefcase"></i> Applications{" "}
                  <span className="tab-count">{profile.Applications?.length ?? 0}</span>
                </button>
                <button
                  className={`tab-btn ${activeTab === "interviews" ? "active" : ""}`}
                  onClick={() => setActiveTab("interviews")}
                >
                  <i className="fa-solid fa-calendar-check"></i> Interviews{" "}
                  <span className="tab-count">{profile.InterviewRounds?.length ?? 0}</span>
                </button>
              </div>

              {/* OVERVIEW TAB */}
              {activeTab === "overview" && (
                <div id="tab-overview">
                  {/* Quick stats */}
                  <div className="quick-stats">
                    <div className="qs">
                      <div className="qs-val" style={{ color: "var(--primary)" }}>
                        {profile.QuickStats?.JobsApplied}
                      </div>
                      <div className="qs-lbl">Jobs Applied</div>
                    </div>
                    <div className="qs">
                      <div className="qs-val" style={{ color: "var(--amber)" }}>
                        {profile.QuickStats?.InterviewRounds}
                      </div>
                      <div className="qs-lbl">Interview Rounds</div>
                    </div>
                    <div className="qs">
                      <div className="qs-val" style={{ color: "var(--green)" }}>
                        {profile.QuickStats?.RoundsCleared}
                      </div>
                      <div className="qs-lbl">Rounds Cleared</div>
                    </div>
                    <div className="qs">
                      <div className="qs-val" style={{ color: "var(--blue)" }}>
                        {profile.QuickStats?.DaysInSystem}
                      </div>
                      <div className="qs-lbl">Days in System</div>
                    </div>
                  </div>

                  {/* Personal + Contact info */}
                  <div className="sec-block">
                    <div className="sec-hd">
                      <h4>
                        <i className="fa-solid fa-user" style={{ color: "var(--primary)" }}></i> Personal &amp; Contact
                      </h4>
                      <button className="btn-ghost btn-xs" onClick={() => setEditModal(true)}>
                        <i className="fa-solid fa-pen"></i> Edit
                      </button>
                    </div>
                    <div className="info-grid">
                      <div className="info-item">
                        <div className="info-label">Full Name</div>
                        <div className="info-value">{profile.Name}</div>
                      </div>
                      <div className="info-item">
                        <div className="info-label">Current Role</div>
                        <div className="info-value">{profile.Role}</div>
                      </div>
                      <div className="info-item">
                        <div className="info-label">Email</div>
                        <div className="info-value">{profile.Email}</div>
                      </div>
                      <div className="info-item">
                        <div className="info-label">Phone</div>
                        <div className="info-value">{profile.Phone}</div>
                      </div>
                      <div className="info-item">
                        <div className="info-label">Location</div>
                        <div className="info-value">{profile.Location}</div>
                      </div>
                      <div className="info-item">
                        <div className="info-label">Work Mode</div>
                        <div className="info-value">{profile.WorkMode}</div>
                      </div>
                      <div className="info-item">
                        <div className="info-label">Expected CTC</div>
                        <div className="info-value">{profile.ExpectedCTC}</div>
                      </div>
                      <div className="info-item">
                        <div className="info-label">Notice Period</div>
                        <div className="info-value">{profile.NoticePeriod}</div>
                      </div>
                      <div className="info-item">
                        <div className="info-label">Total Experience</div>
                        <div className="info-value">{profile.ExperienceYears} years</div>
                      </div>
                      <div className="info-item">
                        <div className="info-label">Current Company</div>
                        <div className="info-value">{profile.CurrentCompany}</div>
                      </div>
                    </div>
                    <div style={{ marginTop: ".75rem", paddingTop: ".65rem", borderTop: "1px solid var(--border-lt)" }}>
                      <div className="info-label" style={{ marginBottom: ".35rem" }}>
                        About
                      </div>
                      <div style={{ fontSize: ".875rem", color: "var(--text)", lineHeight: 1.7 }}>{profile.About}</div>
                    </div>
                  </div>

                  {/* Skills */}
                  <div className="sec-block">
                    <div className="sec-hd">
                      <h4>
                        <i className="fa-solid fa-tags" style={{ color: "var(--primary)" }}></i> Skills
                      </h4>
                    </div>
                    <div>
                      <div
                        style={{
                          fontSize: ".72rem",
                          fontWeight: 700,
                          textTransform: "uppercase",
                          color: "var(--muted)",
                          marginBottom: ".35rem",
                          letterSpacing: ".3px",
                        }}
                      >
                        Primary Skills
                      </div>
                      {(profile.PrimarySkills || []).map((s) => (
                        <span className="skill-chip" key={s}>
                          {s}
                        </span>
                      ))}
                    </div>
                    <div style={{ marginTop: ".65rem" }}>
                      <div
                        style={{
                          fontSize: ".72rem",
                          fontWeight: 700,
                          textTransform: "uppercase",
                          color: "var(--muted)",
                          marginBottom: ".35rem",
                          letterSpacing: ".3px",
                        }}
                      >
                        Secondary Skills
                      </div>
                      {(profile.SecondarySkills || []).map((s) => (
                        <span className="skill-chip" style={{ background: "#f0fdf4", color: "var(--green)" }} key={s}>
                          {s}
                        </span>
                      ))}
                    </div>
                  </div>

                  {/* Work experience */}
                  <div className="sec-block">
                    <div className="sec-hd">
                      <h4>
                        <i className="fa-solid fa-briefcase" style={{ color: "var(--primary)" }}></i> Work Experience
                      </h4>
                    </div>
                    {(profile.Experience || []).map((exp, i) => (
                      <div className="exp-item" key={i}>
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", flexWrap: "wrap", gap: ".3rem" }}>
                          <div>
                            <div className="exp-company">{exp.Company}</div>
                            <div className="exp-role">{exp.Role}</div>
                            <div className="exp-dates">{exp.Dates}</div>
                          </div>
                          {exp.Current && (
                            <span
                              style={{
                                fontSize: ".72rem",
                                background: "var(--green-lt)",
                                color: "var(--green)",
                                padding: "2px 8px",
                                borderRadius: "20px",
                                fontWeight: 600,
                              }}
                            >
                              Current
                            </span>
                          )}
                        </div>
                        <div style={{ fontSize: ".82rem", color: "var(--muted)", marginTop: ".4rem", lineHeight: 1.55 }}>
                          {exp.Desc}
                        </div>
                      </div>
                    ))}
                  </div>

                  {/* Education */}
                  <div className="sec-block">
                    <div className="sec-hd">
                      <h4>
                        <i className="fa-solid fa-graduation-cap" style={{ color: "var(--primary)" }}></i> Education
                      </h4>
                    </div>
                    {(profile.Education || []).map((ed, i) => (
                      <div className="exp-item" style={{ padding: ".5rem 0" }} key={i}>
                        <div className="exp-company">{ed.Degree}</div>
                        <div className="exp-role">{ed.School}</div>
                        <div className="exp-dates">{ed.Dates}</div>
                      </div>
                    ))}
                  </div>

                  {/* Notes section */}
                  <div className="sec-block">
                    <div className="sec-hd">
                      <h4>
                        <i className="fa-solid fa-note-sticky" style={{ color: "var(--amber)" }}></i> HR Notes
                      </h4>
                      <button className="btn btn-warn btn-xs" onClick={() => setAddNoteModal(true)}>
                        <i className="fa-solid fa-plus"></i> Add Note
                      </button>
                    </div>

                    {(profile.Notes || []).map((note, i) => (
                      <div
                        className="note-item"
                        style={note.Highlight ? { background: "#f0f9ff", borderColor: "#bfdbfe" } : {}}
                        key={i}
                      >
                        <div className="note-text">{note.Text}</div>
                        <div className="note-meta">
                          <span style={{ display: "flex", alignItems: "center", gap: ".3rem" }}>
                            <div
                              style={{
                                width: 18,
                                height: 18,
                                borderRadius: "50%",
                                background: note.AuthorColor,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                fontSize: ".55rem",
                                color: "#fff",
                                fontWeight: 700,
                              }}
                            >
                              {note.AuthorInitials}
                            </div>{" "}
                            {note.Author}
                          </span>
                          <span>·</span>
                          <span>{note.Panel}</span>
                          <span>·</span>
                          <span>{note.Time}</span>
                        </div>
                      </div>
                    ))}

                    <div style={{ textAlign: "center", padding: ".5rem", marginTop: ".25rem" }}>
                      <button className="btn-ghost btn-xs" onClick={() => setActiveTab("interviews")}>
                        View all notes in Interviews tab →
                      </button>
                    </div>
                  </div>

                  {/* Activity history */}
                  <div className="sec-block">
                    <div className="sec-hd">
                      <h4>
                        <i className="fa-solid fa-clock-rotate-left" style={{ color: "var(--primary)" }}></i> Activity History
                      </h4>
                      <span style={{ fontSize: ".75rem", color: "var(--muted)" }}>Last 10 events</span>
                    </div>
                    {(profile.Activity || []).map((ev, i, arr) => (
                      <div className="tl-item" key={i} style={i === arr.length - 1 ? { paddingBottom: 0 } : {}}>
                        <div className="tl-dot" style={{ background: ev.Color }}>
                          <i className={`fa-solid ${ev.Icon}`} style={{ fontSize: ".5rem" }}></i>
                        </div>
                        <div className="tl-text">
                          <strong>{ev.Title}</strong> — {ev.Text}
                          <div className="tl-time">{ev.Time}</div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* APPLICATIONS TAB */}
              {activeTab === "applications" && (
                <div id="tab-applications">
                  <div className="sec-block">
                    <div className="sec-hd">
                      <h4>
                        <i className="fa-solid fa-briefcase" style={{ color: "var(--primary)" }}></i> Job Applications
                      </h4>
                      <button className="btn btn-primary btn-xs" onClick={() => {}}>
                        <i className="fa-solid fa-link"></i> Link to Job
                      </button>
                    </div>
                    {(profile.Applications || []).map((app, i) => (
                      <div className="app-row" style={app.Archived ? { opacity: 0.65 } : {}} key={i}>
                        <div style={{ flex: 1 }}>
                          <div style={{ fontWeight: 600, fontSize: ".9rem" }}>{app.Title}</div>
                          <div style={{ fontSize: ".76rem", color: "var(--muted)" }}>{app.Meta}</div>
                        </div>
                        <span className={`stage-badge ${app.StageCls}`}>{app.StageLabel}</span>
                        {app.Archived ? (
                          <button className="btn btn-outline btn-xs" onClick={() => showToast("Loading archived job detail…")}>
                            <i className="fa-solid fa-eye"></i> View
                          </button>
                        ) : (
                          <button className="btn btn-outline btn-xs" onClick={() => {}}>
                            <i className="fa-solid fa-pipe-section"></i> Pipeline
                          </button>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* INTERVIEWS TAB */}
              {activeTab === "interviews" && (
                <div id="tab-interviews">
                  <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: ".75rem" }}>
                    <button className="btn btn-primary btn-sm" onClick={() => {}}>
                      <i className="fa-solid fa-calendar-plus"></i> Schedule Interview
                    </button>
                  </div>
                  <div className="sec-block">
                    <div className="sec-hd">
                      <h4>
                        <i className="fa-solid fa-calendar-check" style={{ color: "var(--primary)" }}></i> Interview Rounds
                      </h4>
                    </div>

                    {(profile.InterviewRounds || []).map((round, i) => (
                      <div className="app-row" key={i}>
                        <div style={{ textAlign: "center", minWidth: 38 }}>
                          <div style={{ fontSize: "1rem", fontWeight: 700, color: round.Action === "feedback" ? "var(--primary)" : undefined }}>
                            {round.Day}
                          </div>
                          <div style={{ fontSize: ".68rem", color: "var(--muted)" }}>{round.Month}</div>
                        </div>
                        <div style={{ width: 3, height: 40, borderRadius: 3, background: round.BarColor, flexShrink: 0 }}></div>
                        <div style={{ flex: 1 }}>
                          <div style={{ fontWeight: 600, fontSize: ".88rem" }}>{round.Title}</div>
                          <div style={{ fontSize: ".75rem", color: "var(--muted)" }}>{round.Meta}</div>
                          {round.Scores && (
                            <div style={{ fontSize: ".75rem", marginTop: ".2rem" }}>
                              {round.Scores.split(" · ").map((s, idx, arr) => (
                                <React.Fragment key={idx}>
                                  <span style={{ color: "var(--green)", fontWeight: 600 }}>{s}</span>
                                  {idx < arr.length - 1 && " · "}
                                </React.Fragment>
                              ))}
                            </div>
                          )}
                        </div>
                        <span
                          style={{
                            fontSize: ".72rem",
                            fontWeight: 700,
                            padding: "2px 8px",
                            borderRadius: "20px",
                            background: round.StatusBg,
                            color: round.StatusColor,
                          }}
                        >
                          {round.StatusLabel}
                        </span>
                        {round.Action === "feedback" ? (
                          <button className="btn btn-warn btn-xs" onClick={openFeedbackModalFresh}>
                            <i className="fa-solid fa-star"></i> Feedback
                          </button>
                        ) : (
                          <button className="btn btn-outline btn-xs" onClick={() => openFeedbackViewModal(round)}>
                            <i className="fa-solid fa-star"></i> View
                          </button>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      {/* </div> */}

      {/* Add Note Modal */}
      <div
        className={`modal-overlay ${addNoteModal ? "open" : ""}`}
        onClick={(e) => e.target === e.currentTarget && setAddNoteModal(false)}
      >
        <div className="modal-box">
          <div className="modal-head">
            <div className="modal-icon" style={{ background: "#fffbeb" }}>
              <i className="fa-solid fa-note-sticky" style={{ color: "var(--amber)" }}></i>
            </div>
            <div style={{ flex: 1 }}>
              <div className="modal-title">Add Note</div>
              <div className="modal-sub">{profile.Name}</div>
            </div>
            <button className="modal-close-btn" onClick={() => setAddNoteModal(false)}>
              <i className="fa-solid fa-times"></i>
            </button>
          </div>
          <div className="modal-body">
            <div className="fg">
              <label>
                Note <span style={{ color: "var(--primary)" }}>*</span>
              </label>
              <textarea className="og-textarea" rows="4" placeholder="Add internal note. Visible only to HR team with access."></textarea>
            </div>
          </div>
          <div className="modal-foot">
            <button className="btn btn-secondary btn-sm" onClick={() => setAddNoteModal(false)}>
              Cancel
            </button>
            <button
              className="btn btn-primary btn-sm"
              onClick={() => {
                setAddNoteModal(false);
                showToast("Note added");
              }}
            >
              <i className="fa-solid fa-check"></i> Save
            </button>
          </div>
        </div>
      </div>

      {/* Feedback Modal */}
      <div
        className={`modal-overlay ${feedbackModal ? "open" : ""}`}
        onClick={(e) => e.target === e.currentTarget && setFeedbackModal(false)}
      >
        <div className="modal-box wide">
          <div className="modal-head">
            <div className="modal-icon" style={{ background: "#fffbeb" }}>
              <i className="fa-solid fa-star" style={{ color: "var(--amber)" }}></i>
            </div>
            <div style={{ flex: 1 }}>
              <div className="modal-title">Submit Feedback</div>
              <div className="modal-sub">{feedbackSub}</div>
            </div>
            <button className="modal-close-btn" onClick={() => setFeedbackModal(false)}>
              <i className="fa-solid fa-times"></i>
            </button>
          </div>
          <div className="modal-body">
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: ".75rem", marginBottom: ".75rem" }}>
              <div>
                <div style={{ fontSize: ".78rem", fontWeight: 700, marginBottom: ".4rem" }}>Technical Skills</div>
                <RatingRow value={r1} onChange={setR1} />
              </div>
              <div>
                <div style={{ fontSize: ".78rem", fontWeight: 700, marginBottom: ".4rem" }}>Communication</div>
                <RatingRow value={r2} onChange={setR2} />
              </div>
              <div>
                <div style={{ fontSize: ".78rem", fontWeight: 700, marginBottom: ".4rem" }}>Problem Solving</div>
                <RatingRow value={r3} onChange={setR3} />
              </div>
              <div>
                <div style={{ fontSize: ".78rem", fontWeight: 700, marginBottom: ".4rem" }}>Culture Fit</div>
                <RatingRow value={r4} onChange={setR4} />
              </div>
            </div>
            <div style={{ background: "var(--gray-lt)", borderRadius: 8, padding: ".65rem .9rem", marginBottom: ".75rem" }}>
              <div style={{ fontSize: ".82rem", fontWeight: 700, marginBottom: ".4rem" }}>Overall Recommendation</div>
              <div style={{ display: "flex", gap: ".75rem" }}>
                <label style={{ display: "flex", alignItems: "center", gap: ".35rem", cursor: "pointer", fontSize: ".85rem" }}>
                  <input type="radio" name="rec" style={{ accentColor: "var(--green)" }} />{" "}
                  <span style={{ color: "var(--green)", fontWeight: 600 }}>Proceed</span>
                </label>
                <label style={{ display: "flex", alignItems: "center", gap: ".35rem", cursor: "pointer", fontSize: ".85rem" }}>
                  <input type="radio" name="rec" style={{ accentColor: "var(--amber)" }} />{" "}
                  <span style={{ color: "var(--amber)", fontWeight: 600 }}>Maybe</span>
                </label>
                <label style={{ display: "flex", alignItems: "center", gap: ".35rem", cursor: "pointer", fontSize: ".85rem" }}>
                  <input type="radio" name="rec" style={{ accentColor: "var(--red)" }} />{" "}
                  <span style={{ color: "var(--red)", fontWeight: 600 }}>Reject</span>
                </label>
              </div>
            </div>
            <textarea className="og-textarea" rows="3" placeholder="Additional comments…"></textarea>
          </div>
          <div className="modal-foot">
            <button className="btn btn-secondary btn-sm" onClick={() => setFeedbackModal(false)}>
              Cancel
            </button>
            <button
              className="btn btn-primary btn-sm"
              onClick={() => {
                setFeedbackModal(false);
                showToast("Feedback submitted");
              }}
            >
              <i className="fa-solid fa-check"></i> Submit Feedback
            </button>
          </div>
        </div>
      </div>

      {/* Create Employee Modal */}
      <div
        className={`modal-overlay ${createEmpModal ? "open" : ""}`}
        onClick={(e) => e.target === e.currentTarget && setCreateEmpModal(false)}
      >
        <div className="modal-box">
          <div className="modal-head">
            <div className="modal-icon" style={{ background: "#dcfce7" }}>
              <i className="fa-solid fa-user-check" style={{ color: "#14532d" }}></i>
            </div>
            <div style={{ flex: 1 }}>
              <div className="modal-title">Create Employee Record</div>
              <div className="modal-sub">{profile.Name}</div>
            </div>
            <button className="modal-close-btn" onClick={() => setCreateEmpModal(false)}>
              <i className="fa-solid fa-times"></i>
            </button>
          </div>
          <div className="modal-body">
            <p style={{ fontSize: ".85rem", color: "var(--muted)", margin: "0 0 .85rem", lineHeight: 1.6 }}>
              Candidate data will be pre-filled in the employee form. Review and complete before saving.
            </p>
            <div className="fg">
              <label>
                Joining Date <span style={{ color: "var(--primary)" }}>*</span>
              </label>
              <input type="date" className="og-input" />
            </div>
            <div className="fg">
              <label>Department</label>
              <input className="og-input" defaultValue="Engineering" />
            </div>
            <div className="fg">
              <label>Designation</label>
              <input className="og-input" defaultValue={profile.Role} />
            </div>
          </div>
          <div className="modal-foot">
            <button className="btn btn-secondary btn-sm" onClick={() => setCreateEmpModal(false)}>
              Cancel
            </button>
            <button
              className="btn btn-primary btn-sm"
              style={{ background: "var(--green)" }}
              onClick={() => {
                setCreateEmpModal(false);
                showToast("Employee creation form opened with pre-filled data");
              }}
            >
              <i className="fa-solid fa-user-plus"></i> Create Employee
            </button>
          </div>
        </div>
      </div>

      {/* Edit Modal */}
      <div
        className={`modal-overlay ${editModal ? "open" : ""}`}
        onClick={(e) => e.target === e.currentTarget && setEditModal(false)}
      >
        <div className="modal-box">
          <div className="modal-head">
            <div className="modal-icon" style={{ background: "var(--gray-lt)" }}>
              <i className="fa-solid fa-pen" style={{ color: "var(--gray)" }}></i>
            </div>
            <div style={{ flex: 1 }}>
              <div className="modal-title">Edit Candidate</div>
            </div>
            <button className="modal-close-btn" onClick={() => setEditModal(false)}>
              <i className="fa-solid fa-times"></i>
            </button>
          </div>
          <div className="modal-body">
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: ".75rem" }}>
              <div className="fg">
                <label>First Name</label>
                <input className="og-input" defaultValue={profile.Name?.split(" ")[0]} />
              </div>
              <div className="fg">
                <label>Last Name</label>
                <input className="og-input" defaultValue={profile.Name?.split(" ").slice(1).join(" ")} />
              </div>
              <div className="fg">
                <label>Email</label>
                <input className="og-input" defaultValue={profile.Email} />
              </div>
              <div className="fg">
                <label>Phone</label>
                <input className="og-input" defaultValue={profile.Phone} />
              </div>
              <div className="fg">
                <label>Expected CTC</label>
                <input className="og-input" defaultValue={profile.ExpectedCTC} />
              </div>
              <div className="fg">
                <label>Notice Period</label>
                <select className="og-select" defaultValue={profile.NoticePeriod}>
                  <option>30 days</option>
                  <option>15 days</option>
                  <option>Immediate</option>
                  <option>60 days</option>
                </select>
              </div>
            </div>
          </div>
          <div className="modal-foot">
            <button className="btn btn-secondary btn-sm" onClick={() => setEditModal(false)}>
              Cancel
            </button>
            <button
              className="btn btn-primary btn-sm"
              onClick={() => {
                setEditModal(false);
                showToast("Candidate updated");
              }}
            >
              <i className="fa-solid fa-check"></i> Save Changes
            </button>
          </div>
        </div>
      </div>

      {toastMsg && (
        <div className="og-toast">
          <i className="fa-solid fa-check-circle" style={{ color: "#4ade80" }}></i>
          {toastMsg}
        </div>
      )}
    </>
  );
}
 ;